import { render, staticRenderFns } from "./SettingsProject.vue?vue&type=template&id=6beeafb8&scoped=true"
import script from "./SettingsProject.vue?vue&type=script&lang=js"
export * from "./SettingsProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beeafb8",
  null
  
)

export default component.exports